import React, { Component } from 'react';
import Head from 'next/head'
import { SeasonDivisionSelector, AgeGroupSelector, Header, Footer, GoalieStat, DivisionPageWrapper } from '../components'
import { fetchAgeGroups } from '../api/age-groups'
import { fetchDivisions } from '../api/divisions'
import { fetchGoalieStats } from '../api/roles'

class PlayerStats extends Component {
  static async getInitialProps({req, query, props}) {
    let params = {'division_id': props.divisionId}
    if (props.competitionId == 'all') {
      params = {'season_id': props.seasonId}
    } else if (props.divisionId == 'all') {
      params = {'competition_id': props.competitionId}
    }
    const stats =  await fetchGoalieStats(params)
    //combine
    const lookup = {};
    if (stats.data) {
      stats.data.forEach(function(stat) {
        if (!lookup[stat.id]) {
          if (stat.stats.adjusted_all_game_seconds > 0) {
            stat.stats.adjusted_play_time = Math.round((stat.stats.adjuted_seconds / stat.stats.adjusted_all_game_seconds) * 100, 2)
          } else {
            stat.stats.adjusted_play_time = 0
          }

          lookup[stat.id] = Object.assign({}, stat)
        } else {
          const result = lookup[stat.id]
          result.stats.played += stat.stats.played
          result.stats.goals_against += stat.stats.goals_against
          result.stats.seconds_played += stat.stats.seconds_played
          result.stats.all_game_seconds += stat.stats.all_game_seconds
          result.stats.adjusted_all_game_seconds += stat.stats.adjusted_all_game_seconds
          result.stats.adjusted_seconds += stat.stats.adjusted_seconds
        }
      })
    }


    const filteredStats = Object.values(lookup).sort(function(b,a) {
      if (a.stats.goals_against_avg < b.stats.goals_against_avg) return 1;
      if (a.stats.goals_against_avg > b.stats.goals_against_avg) return -1;
      if (a.stats.played < b.stats.played) return -1;
      if (a.stats.played > b.stats.played) return 1;
    })

    filteredStats.forEach(function(result) {
        result.stats.play_time = Math.round((result.stats.seconds_played / result.stats.all_game_seconds) * 100, 2)
        result.stats.adjusted_play_time = Math.round((result.stats.adjusted_seconds / result.stats.adjusted_all_game_seconds) * 100, 2)
    })
//console.log(filteredStats)
    return {
      stats: filteredStats,
      organisationId: props.organisationId
    }

  }

  render() {
    const { divisionId, stats,  seasonId, competitionId, seasons, competitions, divisions, organisationId, organisation, pages } = this.props

    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | Player Stats `}</title>
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <h1>{'Goalie Stats'}</h1>
          <SeasonDivisionSelector
            baseUrl={`goalie-stats`}
            seasons={seasons}
            competitions={competitions}
            divisions={divisions}
            divisionId={divisionId}
            seasonId={seasonId}
            competitionId={competitionId}/>

          {stats && stats.length > 0 &&
            <table className="table--player-stats">
              <thead>
                <tr>
                  <th>{'Player'}</th>
                  <th>{'Team'}</th>
                  <th className="u-center">
                    {'Played'}
                  </th>
                  <th className="u-center">{'Goals Against'}</th>
                  <th className="u-center">{'Goals Against Avg'}</th>
                  <th className="u-center">{'Play Time'}</th>
                </tr>
              </thead>
              <tbody>
                {stats.map(s =>
                  <GoalieStat key={s.id} member={s.name} team={s.team.name} stats={s.stats} position={s.player_position} under_18={s.under_18} />
                )}
              </tbody>
            </table>
          }
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}
export default DivisionPageWrapper(PlayerStats);
